(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('formButtonGroup', ['$rootScope', FormButtonGroupFn]);

    function FormButtonGroupFn($rootScope) {
        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                saveDisabled: '=',
                saveFn: '&',
                cancelFn: '&',
                saveHide: '=',
                saveBtnTitle: '@?', // optional: set different button title for save button
                cancelBtnTitle: '@?', // optional: set different button title for cancel button
                saveTooltipShow: '=?', // optional: tooltip on the save button is only shown when true
                saveTooltipKey: '@?' // optional: translation key of the text shown in the save button tooltip
            },
            templateUrl: '/app/global/templates/rf-global-form-button-group.template.html'
        };
        return directive;

        
        function link(scope, element) {            
            var activeHttpRequestsListener = null;            
            scope.saving = false;
            scope.activeRequests = false;

            if (saveButton !== null) {
                activeHttpRequestsListener = $rootScope.$on(
                    'ActiveHttpRequests',
                    function (even, args) {
                        scope.activeRequests = args.activeRequests > 0;                        
                    }
                  );                   
            }

            scope.save = function () {                
                scope.saving = true;                

                var res = scope.saveFn();
                
                if (res && res.then && typeof res.then === 'function') {
                    res.then(function() {
                        scope.saving = false;
                    });
                } else {
                    scope.saving = false;
                }

                return res;
            };

            scope.$on("$destroy", function () {
                if (activeHttpRequestsListener !== null) {
                    activeHttpRequestsListener();
                }
            });

        } // link
    }

})();